import { useEffect, useRef } from "react";
import { useApi } from "./useApi";
import { adminService } from "../services/admin";
import { AdminStatus } from "../types/admin.types";
import { useSession } from "../context/SessionContext";

/**
 * Popula `adminStatus` no contexto uma única vez, quando o `metadata` já tem
 * e-mail. Montado no `ProtectedRoute` — roda em qualquer rota autenticada, sem
 * bloquear a renderização das rotas normais.
 *
 * `GET /admin/status` só exige `Authorization`. Em caso de falha (rede/5xx),
 * assume não-admin para não travar o app; um reload refaz a verificação.
 */
export function useAdminStatus() {
  const { metadata, adminStatus, setAdminStatus } = useSession();
  const statusApi = useApi<AdminStatus>();
  const attempted = useRef(false);

  useEffect(() => {
    if (adminStatus !== null || attempted.current) return;
    if (!metadata.email) return;

    attempted.current = true;

    statusApi
      .request(() => adminService.getStatus(statusApi.apiFetch, metadata.email), {
        showErrorToast: false,
      })
      .then((result) => {
        if (result) {
          setAdminStatus(result);
        } else {
          setAdminStatus({
            email: metadata.email,
            exists: true,
            is_admin: false,
          });
        }
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [metadata.email, adminStatus]);
}
